import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import * as serviceWorker from './serviceWorker';
import AuthContextProvider from './context/auth.context';
import AppContextProvider from './context/app.context';
// import 'bootstrap/dist/css/bootstrap-grid.min.css';



ReactDOM.render(
    <AppContextProvider>
        <AuthContextProvider>
            <App />
        </AuthContextProvider>
    </AppContextProvider>
    , document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.register();
